// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SearchBarTimePicker_body__FVytw {\n  display: flex;\n  align-items: center;\n}\n\n.SearchBarTimePicker_seperator__24d4p {\n  padding: 0 10px;\n}", "",{"version":3,"sources":["webpack://./src/views/Search/SearchDesktop/SearchBar/SearchBarTimePicker/SearchBarTimePicker.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".body {\n  display: flex;\n  align-items: center;\n}\n\n.seperator {\n  padding: 0 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": "SearchBarTimePicker_body__FVytw",
	"seperator": "SearchBarTimePicker_seperator__24d4p"
};
export default ___CSS_LOADER_EXPORT___;
